import React from "react";
import PropTypes from "prop-types";
import LoadingButton from "@mui/lab/LoadingButton";
import { SFLoadingIcon } from "../icons";
import { SFStack } from "../grid";

//#region internal button styles
const LoadingButtonStyled = ({
  loadingVariant = "primary",
  sx,
  children,
  variant,
  size,
  type,
  onClick,
  fullWidth,
  disabled = false,
  className,
  loading = false,
  loadingLabel = null,
}) => {
  return (
    <LoadingButton
      variant={variant}
      size={size}
      type={type}
      onClick={onClick}
      sx={(theme) => ({
        ...sx,
        height: sx && sx.height ? sx.height : "100%",
        minWidth: "90px",
        "&.Mui-disabled.MuiLoadingButton-loading": {
          ...(loadingVariant === "secondary" && {
            backgroundColor:
              variant === "primary"
                ? theme.palette.grey500.main
                : theme.palette.white.main,
          }),
        },
      })}
      fullWidth={fullWidth}
      disabled={disabled}
      loading={loading}
      {...(loadingVariant === "secondary" && {
        loadingIndicator: (
          <SFStack
            alignItems="center"
            justifyContent="center"
            direction="row"
            spacing={0.5}
            sx={(theme) => ({
              "& .MuiSvgIcon-root": {
                animation: "spin 3s linear infinite",
              },
              "& .text": {
                color:
                  variant === "primary"
                    ? theme.palette.white.main
                    : theme.palette.grey500.main,
              },
            })}
          >
            <SFLoadingIcon
              color={variant === "primary" ? "white" : "grey500"}
            />
            {loadingLabel && <div className="text">{loadingLabel}</div>}
          </SFStack>
        ),
      })}
      {...(className && { className: className })}
    >
      {children}
    </LoadingButton>
  );
};

LoadingButtonStyled.defaultProps = {
  variant: "primary",
  size: "medium",
  disabled: false,
  children: null,
  type: "submit",
  onClick: null,
  fullWidth: false,
  fullHeight: false,
  loading: false,
};

LoadingButtonStyled.propTypes = {
  variant: PropTypes.oneOf(["primary", "secondary"]),
  loadingVariant: PropTypes.oneOf(["primary", "secondary"]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool,
  sx: PropTypes.object,
  loading: PropTypes.bool,
};
//#endregion

export default LoadingButtonStyled;
